import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { pageAPI } from '../../services/api';
import './Page.css';

const PageView = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  const fetchPage = async () => {
    try {
      setIsLoading(true);
      const response = await pageAPI.getBySlug(slug);
      setPage(response.data);
    } catch (error) {
      setError('Page not found');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="page-container">
        <div className="page-loading">Loading...</div>
      </div>
    );
  }

  if (error || !page) {
    return (
      <main className="genres-page">
        <div className="page-error">
          <h1>Page Not Found</h1>
          <p>The page you're looking for doesn't exist.</p>
          <Link to="/" className="btn-back">
            <ChevronLeft size={18} /> Back to Home
          </Link>
        </div>
      </main>
    );
  }

  return (
    <main className="genres-page">
      <div className="container">
        <div className="page-header">
          <h2>{page.title}</h2>
          {page.excerpt && <p className="page-excerpt">{page.excerpt}</p>}
        </div>
        
        <div 
          className="page-body"
          dangerouslySetInnerHTML={{ __html: page.content }}
        />
        
        <footer className="page-footer">
          <p>Last updated: {new Date(page.updatedAt).toLocaleDateString()}</p>
        </footer>
      </div>
    </main>
  );
};

export default PageView;
